
    // this file was auto generated by python script
    import Map from './Map';
    export default Map;
    